<template>
    <v-card light>
        <v-card-text>
            <v-container fluid>
                <v-layout row wrap>
                    <v-flex xs12 text-xs-center>
                        <h5>{{ title }}</h5>
                    </v-flex>
                    <v-flex xs12 class="own-flex" mt-2>
                        <div
                            class="fab-img"
                            :style="{'background-image': 'url(' + infoTeam.image.original ? infoTeam.image.original : infoTeam.image.letter + ')'}"
                        ></div>
                    </v-flex>
                    <v-flex xs12 text-xs-center mt-2>
                        <div class="headline green--text">{{ infoTeam.name }}</div>
                        <div v-if="infoTeam.place">{{ infoTeam.created_by }}</div>
                        <div v-if="infoTeam.place">{{ infoTeam.place.place_name }}</div>
                        <div v-if="infoTeam.place">{{ infoTeam.place.address }}</div>
                        <div v-if="infoTeam.place">{{ infoTeam.place.city + ", "+ infoTeam.place.state + ", "+infoTeam.place.country }}</div>
                    </v-flex>
                </v-layout>

                <v-layout mt-5 row wrap>
                  <v-flex xs12 text-xs-center>
                      <h6>Jugadores</h6>
                  </v-flex>
                    <v-flex xs12>
                        <v-list two-line class="list-height" light>
                            <template v-for="player in players">
                                <v-divider></v-divider>
                                <v-list-tile avatar :key="player.name">
                                    <!--<v-list-tile-avatar>
                                        <img :src="player.picture">
                                    </v-list-tile-avatar>-->
                                    <v-list-tile-content>
                                        <v-list-tile-title v-html="player.name"></v-list-tile-title>
                                        <v-list-tile-sub-title v-html="player.rol"></v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </template>
                        </v-list>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "Team",
        props: {
            title: {required: true},
            infoTeam: {required: true},
            players: {required: true}

        },
        data() {
            return {
            }
        }
    }
</script>

<style lang="css" scoped>
    .fab-img {
        background-size: contain;
        background-repeat: no-repeat;
        width: 120px;
        height: 120px;
        border-radius: 50%;
        box-shadow: 0 3px 5px -1px rgba(0,0,0,.2), 0 6px 10px rgba(0,0,0,.14), 0 1px 18px rgba(0,0,0,.12);
    }
    .own-flex {
        display: flex;
        justify-content: center;
    }
    .list-height {
        max-height: calc(650px - 350px);
        overflow-y: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/partnering/Team.vue